import { createFileRoute } from '@tanstack/react-router'
import { ListVaccinePage } from '_/features/pets/ui/pages/list-vaccine-page'

const ListVaccineRoute = () => {
	const { petId } = Route.useParams()
	return <ListVaccinePage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/vaccines/')({
	staticData: { title: 'vaccines_title' },
	component: ListVaccineRoute,
})
